(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["icy-bundle-wheel-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'icy-spin-popup-state-v4';
    const cookieKey = 'icy_spin_popup_state';

    function getCookieState() {
      const prefix = `${cookieKey}=`;
      const storedCookie = document.cookie
        .split(';')
        .map((cookie) => cookie.trim())
        .find((cookie) => cookie.indexOf(prefix) === 0);

      return storedCookie
        ? decodeURIComponent(storedCookie.slice(prefix.length))
        : 'new';
    }

    function getVisitorState() {
      let localState = 'new';

      try {
        localState = window.localStorage.getItem(storageKey) || 'new';
      } catch (error) {
        // Fall back to the persistent cookie below.
      }

      const cookieState = getCookieState();

      if (localState === 'played' || cookieState === 'played') return 'played';
      if (localState === 'dismissed' || cookieState === 'dismissed') return 'dismissed';
      if (localState === 'shown' || cookieState === 'shown') return 'shown';

      return 'new';
    }

    function setVisitorState(state) {
      try {
        window.localStorage.setItem(storageKey, state);
      } catch (error) {
        // The cookie below still preserves the visitor state.
      }

      document.cookie = `${cookieKey}=${encodeURIComponent(state)}; Max-Age=31536000; Path=/; SameSite=Lax`;
    }

    function initializePopup(popup) {
      if (!popup || popup.dataset.initialized === 'true') return;

      popup.dataset.initialized = 'true';

      const delay = Number(popup.dataset.delay || 5000);
      const closeButtons = popup.querySelectorAll('[data-icy-close]');
      const launcher = popup.querySelector('[data-icy-launcher]');
      const form = popup.querySelector('form.icy-spin-popup__form');
      const submit = popup.querySelector('[data-icy-submit]');
      const wheel = popup.querySelector('[data-icy-wheel]');
      const wheelStage = popup.querySelector('.icy-spin-popup__wheel-stage');
      const entry = popup.querySelector('[data-icy-entry]');
      const result = popup.querySelector('[data-icy-result]');
      const birthdayNote = popup.querySelector('[data-icy-birthday-note]');
      const birthDay = popup.querySelector('[data-icy-birth-day]');
      const birthMonth = popup.querySelector('[data-icy-birth-month]');
      const birthYear = popup.querySelector('[data-icy-birth-year]');
      let isSubmitting = false;
      let lockedScrollY = 0;
      let pageLockSnapshot = null;

      function lockPage() {
        if (pageLockSnapshot) return;

        lockedScrollY = window.scrollY || window.pageYOffset || 0;
        pageLockSnapshot = {
          htmlOverflow: document.documentElement.style.overflow,
          bodyPosition: document.body.style.position,
          bodyTop: document.body.style.top,
          bodyWidth: document.body.style.width,
          bodyOverflow: document.body.style.overflow
        };

        document.documentElement.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${lockedScrollY}px`;
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
      }

      function unlockPage() {
        if (!pageLockSnapshot) return;

        document.documentElement.style.overflow = pageLockSnapshot.htmlOverflow;
        document.body.style.position = pageLockSnapshot.bodyPosition;
        document.body.style.top = pageLockSnapshot.bodyTop;
        document.body.style.width = pageLockSnapshot.bodyWidth;
        document.body.style.overflow = pageLockSnapshot.bodyOverflow;
        window.scrollTo(0, lockedScrollY);
        pageLockSnapshot = null;
      }

      function openPopup() {
        popup.classList.add('is-open');

        if (launcher) {
          launcher.hidden = true;
        }

        lockPage();
      }

      function closePopup() {
        popup.classList.remove('is-open');
        unlockPage();

        if (getVisitorState() !== 'played') {
          setVisitorState('dismissed');
        }

        if (launcher) {
          launcher.hidden = true;
        }
      }

      function revealAlmost() {
        if (wheel) {
          wheel.classList.add('is-spinning');
        }

        window.setTimeout(() => {
          if (wheelStage) {
            wheelStage.classList.add('is-faded');
          }

          if (entry) {
            entry.hidden = true;
          }

          if (result) {
            result.hidden = false;
          }
        }, 3650);
      }

      function submitDetails() {
        if (!form || isSubmitting || !form.reportValidity()) return;

        isSubmitting = true;

        const birthday = [
          birthDay ? birthDay.value.trim() : '',
          birthMonth ? birthMonth.value.trim() : '',
          birthYear ? birthYear.value.trim() : ''
        ].filter(Boolean).join('/');

        if (birthdayNote) {
          birthdayNote.value = birthday
            ? `Birthday: ${birthday}`
            : 'Birthday not provided';
        }

        if (submit) {
          submit.disabled = true;
          submit.textContent = 'Spinning...';
        }

        setVisitorState('played');

        if (launcher) {
          launcher.hidden = true;
        }

        revealAlmost();

        window.fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: {
            Accept: 'text/html'
          }
        }).catch(() => {
          // The result still appears if the signup request is interrupted.
        });
      }

      closeButtons.forEach((button) => {
        button.addEventListener('click', closePopup);
      });

      if (launcher) {
        launcher.addEventListener('click', openPopup);
      }

      if (submit) {
        submit.addEventListener('click', submitDetails);
      }

      if (form) {
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          submitDetails();
        });
      }

      const visitorState = getVisitorState();

      if (
        visitorState === 'played' ||
        visitorState === 'dismissed' ||
        visitorState === 'shown'
      ) {
        popup.classList.remove('is-open');

        if (launcher) {
          launcher.hidden = true;
        }
      } else {
        /*
          Reserve this visitor's one automatic impression immediately. This
          prevents refreshes and product-page navigation from scheduling the
          popup again before the original delay finishes.
        */
        setVisitorState('shown');

        if (launcher) {
          launcher.hidden = true;
        }

        window.setTimeout(openPopup, delay);
      }
    }

    function initializeAll(root) {
      if (root.matches && root.matches('[data-icy-spin-popup]')) {
        initializePopup(root);
      }

      root.querySelectorAll('[data-icy-spin-popup]').forEach(initializePopup);
    }

    function start() {
      initializeAll(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      document.querySelectorAll('[data-icy-spin-popup].is-open').forEach((popup) => {
        const closeButton = popup.querySelector('[data-icy-close]');

        if (closeButton) {
          closeButton.click();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icy-hero-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initializeHero(root) {
      if (!root || root.dataset.icyInitialized === 'true') return;

      const slides = Array.from(root.querySelectorAll('[data-icy-slide]'));
      const thumbnails = Array.from(root.querySelectorAll('[data-icy-thumbnail]'));
      const backgrounds = Array.from(root.querySelectorAll('[data-icy-background]'));
      const previousButton = root.querySelector('[data-icy-previous]');
      const nextButton = root.querySelector('[data-icy-next]');
      const currentCount = root.querySelector('[data-icy-current-count]');
      const thumbnailRail = root.querySelector('[data-icy-thumbnails]');
      const autoplayEnabled = root.dataset.autoplay === 'true';
      const autoplayDelay = Number(root.dataset.autoplayDelay || 6000);
      let activeIndex = Math.max(0, thumbnails.findIndex((thumbnail) => thumbnail.classList.contains('is-active')));
      let autoplayTimer = null;

      if (!slides.length || !thumbnails.length) {
        root.dataset.icyInitialized = 'true';
        return;
      }

      function formatCount(value) {
        return String(value).padStart(2, '0');
      }

      function selectSlide(index, options = {}) {
        const normalizedIndex = (index + slides.length) % slides.length;

        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === normalizedIndex;
          slide.hidden = !isActive;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
        });

        backgrounds.forEach((background, backgroundIndex) => {
          const isActive = backgroundIndex === normalizedIndex;
          background.hidden = !isActive;
          background.classList.toggle('is-active', isActive);
        });

        thumbnails.forEach((thumbnail, thumbnailIndex) => {
          const isActive = thumbnailIndex === normalizedIndex;
          thumbnail.classList.toggle('is-active', isActive);
          thumbnail.setAttribute('aria-selected', String(isActive));
          thumbnail.tabIndex = isActive ? 0 : -1;
        });

        activeIndex = normalizedIndex;

        if (currentCount) {
          currentCount.textContent = formatCount(activeIndex + 1);
        }

        thumbnails[activeIndex].scrollIntoView({
          behavior: options.instant ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center'
        });

        if (options.focus) {
          thumbnails[activeIndex].focus();
        }
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          window.clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function startAutoplay() {
        stopAutoplay();

        if (!autoplayEnabled || slides.length < 2) return;

        autoplayTimer = window.setInterval(() => {
          selectSlide(activeIndex + 1);
        }, autoplayDelay);
      }

      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          selectSlide(Number(thumbnail.dataset.slideIndex));
          startAutoplay();
        });
      });

      if (previousButton) {
        previousButton.addEventListener('click', () => {
          selectSlide(activeIndex - 1);
          startAutoplay();
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          selectSlide(activeIndex + 1);
          startAutoplay();
        });
      }

      if (thumbnailRail) {
        thumbnailRail.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            selectSlide(activeIndex + 1, { focus: true });
          }

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            selectSlide(activeIndex - 1, { focus: true });
          }
        });
      }

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('focusin', stopAutoplay);
      root.addEventListener('focusout', startAutoplay);

      root._icySelectBlock = (blockId) => {
        const matchingSlide = slides.find((slide) => slide.dataset.blockId === blockId);

        if (matchingSlide) {
          stopAutoplay();
          selectSlide(Number(matchingSlide.dataset.slideIndex), { instant: true });
        }
      };

      root.dataset.icyInitialized = 'true';
      selectSlide(activeIndex, { instant: true });
      startAutoplay();
    }

    function initializeAll(scope = document) {
      if (scope.matches && scope.matches('[data-icy-editorial-hero]')) {
        initializeHero(scope);
      }

      scope.querySelectorAll('[data-icy-editorial-hero]').forEach(initializeHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const root =
        event.target.closest?.('[data-icy-editorial-hero]') ||
        event.target.querySelector?.('[data-icy-editorial-hero]');

      if (root && root._icySelectBlock && event.detail?.blockId) {
        root._icySelectBlock(event.detail.blockId);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icy-mega-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const DESKTOP_QUERY = '(min-width: 990px)';

    function initializeHeader(root) {
      if (!root || root.dataset.icyMegaInitialized === 'true') return;

      const triggers = Array.from(root.querySelectorAll('[data-icy-menu-trigger]'));
      const panels = Array.from(root.querySelectorAll('[data-icy-menu-panel]'));
      const mobileToggle = root.querySelector('[data-icy-mobile-toggle]');
      const mobileDrawer = root.querySelector('[data-icy-mobile-drawer]');
      const mobileClose = root.querySelector('[data-icy-mobile-close]');
      const cartTrigger = root.querySelector('[data-icy-cart-trigger]');
      const mobileDetails = Array.from(root.querySelectorAll('.icy-mega-header__mobile-item'));
      const desktopMedia = window.matchMedia(DESKTOP_QUERY);
      const isHomepageHeader = root.dataset.pageMode === 'home';
      let closeTimer = null;
      let compactFrame = null;

      function syncHomepageHeaderMode() {
        compactFrame = null;
        if (!isHomepageHeader) return;

        const hero = document.querySelector('[data-icy-editorial-hero]');
        const headerBottom = root.getBoundingClientRect().bottom;
        const compactThreshold = Math.max(70, headerBottom);
        const shouldCompact = hero
          ? hero.getBoundingClientRect().bottom <= compactThreshold
          : window.scrollY > Math.max(320, window.innerHeight * 0.65);

        root.classList.toggle('is-compact', shouldCompact);
      }

      function requestHomepageHeaderSync() {
        if (!isHomepageHeader || compactFrame) return;
        compactFrame = window.requestAnimationFrame(syncHomepageHeaderMode);
      }

      if (isHomepageHeader) {
        window.addEventListener('scroll', requestHomepageHeaderSync, { passive: true });
        window.addEventListener('resize', requestHomepageHeaderSync);
        requestHomepageHeaderSync();
      }

      function clearCloseTimer() {
        if (closeTimer) {
          window.clearTimeout(closeTimer);
          closeTimer = null;
        }
      }

      function closeDesktopPanels() {
        clearCloseTimer();

        triggers.forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
        });

        panels.forEach((panel) => {
          panel.hidden = true;
          panel.classList.remove('is-open');
        });
      }

      function openDesktopPanel(trigger) {
        if (!desktopMedia.matches || !trigger) return;

        clearCloseTimer();
        const panelId = trigger.dataset.panelId;

        triggers.forEach((item) => {
          item.setAttribute('aria-expanded', String(item === trigger));
        });

        panels.forEach((panel) => {
          const isActive = panel.id === panelId;
          panel.hidden = !isActive;
          panel.classList.toggle('is-open', isActive);
        });
      }

      function scheduleDesktopClose() {
        clearCloseTimer();
        closeTimer = window.setTimeout(closeDesktopPanels, 120);
      }

      function setMobileDrawer(open) {
        if (!mobileDrawer || !mobileToggle) return;

        mobileDrawer.hidden = !open;
        mobileToggle.setAttribute('aria-expanded', String(open));
        mobileToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
        document.documentElement.classList.toggle('icy-mega-menu-open', open);

        if (!open) {
          mobileDetails.forEach((details) => {
            details.open = false;
          });
        }
      }

      function openCartDrawer(event) {
        event.preventDefault();
        closeDesktopPanels();
        setMobileDrawer(false);

        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { open: true }
          })
        );
      }

      triggers.forEach((trigger) => {
        trigger.addEventListener('mouseenter', () => openDesktopPanel(trigger));
        trigger.addEventListener('focus', () => openDesktopPanel(trigger));
        trigger.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            openDesktopPanel(trigger);
            const panel = document.getElementById(trigger.dataset.panelId);
            panel?.querySelector('a')?.focus();
          }

          if (event.key === 'Escape') {
            closeDesktopPanels();
            trigger.focus();
          }
        });
      });

      root.addEventListener('mouseenter', clearCloseTimer);
      root.addEventListener('mouseleave', scheduleDesktopClose);
      root.addEventListener('focusout', (event) => {
        if (desktopMedia.matches && !root.contains(event.relatedTarget)) {
          closeDesktopPanels();
        }
      });

      panels.forEach((panel) => {
        panel.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            const trigger = triggers.find((item) => item.dataset.panelId === panel.id);
            closeDesktopPanels();
            trigger?.focus();
          }
        });
      });

      mobileToggle?.addEventListener('click', () => {
        setMobileDrawer(mobileDrawer?.hidden !== true ? false : true);
      });

      mobileClose?.addEventListener('click', () => {
        setMobileDrawer(false);
        mobileToggle?.focus();
      });

      cartTrigger?.addEventListener('click', openCartDrawer);

      mobileDetails.forEach((details) => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;

          mobileDetails.forEach((otherDetails) => {
            if (otherDetails !== details) otherDetails.open = false;
          });
        });
      });

      mobileDrawer?.addEventListener('click', (event) => {
        if (event.target.closest('a')) setMobileDrawer(false);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        closeDesktopPanels();
        setMobileDrawer(false);
      });

      document.addEventListener('pointerdown', (event) => {
        if (!root.contains(event.target)) {
          closeDesktopPanels();
          setMobileDrawer(false);
        }
      });

      desktopMedia.addEventListener('change', () => {
        closeDesktopPanels();
        setMobileDrawer(false);
      });

      root.dataset.icyMegaInitialized = 'true';
    }

    function initializeAll(scope = document) {
      if (scope.matches?.('[data-icy-mega-header]')) initializeHeader(scope);
      scope.querySelectorAll?.('[data-icy-mega-header]').forEach(initializeHeader);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target.closest?.('[data-icy-mega-header]');
      if (!root || !window.matchMedia(DESKTOP_QUERY).matches) return;

      const trigger = root.querySelector(
        `[data-icy-menu-trigger][data-panel-id$="-panel-${event.detail?.blockId}"]`
      );
      trigger?.dispatchEvent(new Event('mouseenter'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
